import { render, staticRenderFns } from "./BrandGrowthChart.vue?vue&type=template&id=5c9ef017&"
import script from "./BrandGrowthChart.vue?vue&type=script&lang=js&"
export * from "./BrandGrowthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports